import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const studyFields: FieldInterface[] = [
  {
    key: 'harvestId',
    originKey: 'harvest_id',
    type: FIELD_TYPES.string,
  },
  {
    key: 'input',
    originKey: 'input',
    type: FIELD_TYPES.object,
  },
  {
    key: 'kind',
    originKey: 'kind',
    type: FIELD_TYPES.string,
  },
  {
    key: 'engineResults',
    originKey: 'engine_results',
    objectType: 'EngineResults',
    objectTypePath: 'src/services/mappings/study/study.types',
    type: FIELD_TYPES.object,
  },
  {
    key: 'harvestInput',
    originKey: 'harvest_input',
    type: FIELD_TYPES.object,
  },
  {
    key: 'event',
    originKey: 'event',
    type: FIELD_TYPES.object,
  },
  {
    key: 'createdAt',
    originKey: 'created_at',
    type: FIELD_TYPES.date,
  },
]

const studyRelations: RelationInterface[] = [
  {
    key: '_person',
    originKey: 'person',
    objectType: OBJECT_TYPES.person,
    isMultiple: false,
  },
  {
    key: '_circuits',
    originKey: 'circuits',
    objectType: OBJECT_TYPES.genericModel,
    isMultiple: true,
  },
  {
    key: '_previousStep',
    originKey: 'previous_step',
    objectType: OBJECT_TYPES.genericModel,
    isMultiple: false,
  },
  {
    key: '_retirementComplementaryInfo',
    originKey: 'retirement_complementary_info',
    objectType: OBJECT_TYPES.genericModel,
    isMultiple: false,
  },
  {
    key: '_studyHistory',
    originKey: 'study_history',
    objectType: OBJECT_TYPES.studyHistory,
    isMultiple: true,
  },
  {
    key: '_studyReport',
    originKey: 'study_report',
    objectType: OBJECT_TYPES.studyReport,
    isMultiple: false,
  },
  {
    key: '_recommendationReceived',
    originKey: 'recommendation_received',
    objectType: OBJECT_TYPES.recommendation,
    isMultiple: false,
  },
]

export { studyFields, studyRelations }
